<template>
	<div class="sticky-summary">
		<div class="flex xs-12 mb2 xs-middle" slot="headline">
			<div class="fs5 lh125 fw7 c1">{{ $t("claim_balance") }}</div>
		</div>
		<j-card class="xs-12 flex wrap bg5 p4">
			<div class="xs-12 " v-for="(item, i) in benefitTree" :key="item.typeId">
				<claim-balance-node :node="item" class="mb2" />
			</div>

			<!-- When empty -->
			<div class="xs-12 ta2 fs3 c6 fw7" v-if="benefitTree.length === 0">
				{{ $t("errors.no_data") }}
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import ClaimBalanceNode from "./ClaimBalanceNode"

export default {
	components: {
		JCard,
		ClaimBalanceNode
	},
	props: {
		/**
		 * From api - claims.claimBalance
		 */
		claimBalance: {
			type: Array,
			default: () => []
		},

		/**
		 * From api - claims.policy.acceptedOffer.product.benefitGraph
		 */
		benefitGraph: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		/**
		 * Combination of benefitClaims and benefitGraph
		 * We are displaying benefits as a tree but showing remaining values from benefitClaims
		 */
		benefitTree() {
			const recursion = arr => {
				arr.forEach(item => {
					const foundBenefit = this.claimBalance?.find(
						benefit => benefit.typeId === item.typeId
					)
					item.formattedValue = foundBenefit?.formattedValue
					item.isValid = foundBenefit?.isValid
					if (item.children) recursion(item.children)
				})
			}
			let benefitGraphWithRemaningValue = JSON.parse(
				JSON.stringify(this.benefitGraph)
			) // immutable

			recursion(benefitGraphWithRemaningValue)
			return benefitGraphWithRemaningValue
		}
	}
}
</script>